(function (root, factory) {
  "use strict";

  var api = factory();
  if (typeof module === "object" && module.exports) {
    module.exports = api;
  }
  if (root && root.document) {
    api.neutraliseLegacyShopifyContact(root.document);
    if (root.document.readyState === "loading") {
      root.document.addEventListener("DOMContentLoaded", api.initialise, { once: true });
    } else {
      api.initialise();
    }
  }
})(typeof window !== "undefined" ? window : null, function () {
  "use strict";

  var ALLOWED_API_BASES = [
    "https://dev-api.teleadapt.com",
    "https://api.teleadapt.com"
  ];
  var COUNTRY_CODES = "AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW".split(" ");
  var COUNTRY_ALIASES = {
    GB: ["UK", "U.K.", "Great Britain", "Britain", "England", "Scotland", "Wales", "Northern Ireland"],
    US: ["US", "USA", "U.S.", "America"],
    KR: ["South Korea", "Korea, Republic of"],
    KP: ["North Korea", "Korea, Democratic People's Republic of"],
    RU: ["Russia", "Russian Federation"],
    CZ: ["Czech Republic"],
    TR: ["Turkey"],
    AE: ["UAE"],
    BO: ["Bolivia"],
    BN: ["Brunei"],
    CD: ["Democratic Republic of the Congo", "DR Congo"],
    CG: ["Republic of the Congo"],
    CI: ["Ivory Coast"],
    LA: ["Laos"],
    MD: ["Moldova"],
    TW: ["Taiwan"],
    TZ: ["Tanzania"],
    VA: ["Vatican City"],
    VN: ["Vietnam"]
  };
  var US_OFFICE_CODES = new Set("US CA MX BZ CR SV GT HN NI PA AR BO BR CL CO EC FK GF GS GY PE PY SR UY VE AI AG AW BS BB BM BQ VG KY CU CW DM DO GD GP HT JM MQ MS PR BL KN LC MF VC SX TT TC VI".split(" "));
  var CONTEXTS = {
    "Hotel": "hotel",
    "Portable Power": "portable_power",
    "Consumer": "consumer"
  };
  var FORM_SELECTOR = "#contact_form";
  var SUBMIT_SELECTOR = "#ta-quotation-submit";
  var STATUS_ID = "ta-quotation-status";
  var TURNSTILE_ID = "ta-quotation-turnstile";
  var TURNSTILE_SITE_KEY = "0x4AAAAAAEDHIc-JmyqtxRyG";
  var TURNSTILE_SCRIPT_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
  var SUBSCRIPTION_STATES = ["offer", "dont_offer", "re_offer", "unavailable"];
  var SUBSCRIPTION_DEBOUNCE_MS = 400;
  var SUBSCRIPTION_BUDGET_MS = 5000;
  var THANK_YOU_PATH = "/pages/request-quote-thank-you-with-ref";
  var REFERENCE_STORAGE_KEY = "ta_quote_ref";
  var PROGRESS_STYLE_ID = "ta-quotation-progress-style";
  var VALIDATION_STYLE_ID = "ta-quotation-validation-style";
  var DESKTOP_LAYOUT_QUERY = "(min-width: 768px)";
  var PRODUCT_RESOLUTION_ERROR = "We couldn’t verify the selected product. Please reselect the product and try again. If the problem continues, please contact us.";
  var PROJECT_SCALES = {
    hotel: {
      "1-50": { type: "range", minimum: 1, maximum: 50 },
      "51-100": { type: "range", minimum: 51, maximum: 100 },
      "101-250": { type: "range", minimum: 101, maximum: 250 },
      "251-500": { type: "range", minimum: 251, maximum: 500 },
      "501-1000": { type: "range", minimum: 501, maximum: 1000 },
      "1001-5000": { type: "range", minimum: 1001, maximum: 5000 },
      "5001+": { type: "at_least", minimum: 5001 }
    },
    quantity: {
      "1-10": { type: "range", minimum: 1, maximum: 10 },
      "11-50": { type: "range", minimum: 11, maximum: 50 },
      "51-100": { type: "range", minimum: 51, maximum: 100 },
      "101-250": { type: "range", minimum: 101, maximum: 250 },
      "251-500": { type: "range", minimum: 251, maximum: 500 },
      "501-1000": { type: "range", minimum: 501, maximum: 1000 },
      "1001-5000": { type: "range", minimum: 1001, maximum: 5000 },
      "5001+": { type: "at_least", minimum: 5001 }
    }
  };
  var turnstileLoadPromise;

  function neutraliseLegacyShopifyContact(documentLike) {
    var form = documentLike.querySelector(FORM_SELECTOR);
    var formType = form && form.querySelector('input[name="form_type"]');
    var legacyContact = form && /\/contact(?:[?#]|$)/.test(String(form.getAttribute("action") || "")) &&
      formType && ["contact", "customer"].indexOf(String(formType.value || "")) !== -1;
    if (!legacyContact) return form;
    form.removeAttribute("action");
    if (form.dataset.taNativeSubmissionBlocked !== "true") {
      form.dataset.taNativeSubmissionBlocked = "true";
      form.addEventListener("submit", function (event) { event.preventDefault(); }, true);
    }
    return form;
  }

  function normaliseCountry(value) {
    return String(value || "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
  }

  function countryIndex(displayNames) {
    if (!displayNames) {
      if (typeof Intl !== "object" || typeof Intl.DisplayNames !== "function") {
        throw new Error("Country names are unavailable in this browser.");
      }
      displayNames = new Intl.DisplayNames(["en"], { type: "region" });
    }
    return COUNTRY_CODES.map(function (code) {
      var name = displayNames.of(code);
      if (!name || name === code) {
        throw new Error("A canonical country name is unavailable.");
      }
      return {
        code: code,
        name: name,
        aliases: COUNTRY_ALIASES[code] || [],
        assigned_sales_office: US_OFFICE_CODES.has(code) ? "us" : "china"
      };
    });
  }

  function resolveCountry(value, countries) {
    var term = normaliseCountry(value);
    var matches;
    if (!term) return null;
    matches = countries.filter(function (country) {
      return [country.name].concat(country.aliases).some(function (name) {
        return normaliseCountry(name) === term;
      });
    });
    return matches.length === 1 ? matches[0] : null;
  }

  function endpointFor(apiBase) {
    var normalised = String(apiBase || "").replace(/\/$/, "");
    if (ALLOWED_API_BASES.indexOf(normalised) === -1) {
      throw new Error("Quotation API configuration is unavailable.");
    }
    return normalised + "/api/v1/quotations";
  }

  function selectedValue(form, name) {
    var field = form.querySelector('[name="' + name + '"]');
    if (field && (field.type === "radio" || field.type === "checkbox")) {
      field = form.querySelector('[name="' + name + '"]:checked');
    }
    return field ? String(field.value || "").trim() : "";
  }

  function optional(value) {
    value = String(value || "").trim();
    return value || null;
  }

  function isPlaceholder(value) {
    value = String(value || "").trim();
    return !value || /^(?:please\s+)?(?:select|choose)(?:\s+(?:a|an|the|your))?(?:\s+[^.]+)?\s*\.{0,3}$/i.test(value);
  }

  function validationIssues(form, countries) {
    var issues = [];
    var contextLabel = selectedValue(form, "project_type");
    var context = CONTEXTS[contextLabel];
    function field(name) { return form.querySelector('[name="' + name + '"]'); }
    function requireValue(name, message) {
      var control = field(name);
      if (!control || isPlaceholder(selectedValue(form, name))) issues.push({ field: control, name: name, message: message });
    }

    if (!context) issues.push({ field: field("project_type"), name: "project_type", message: "Please select a quotation type." });
    requireValue("contact[First Name]", "Please enter your first name.");
    requireValue("contact[Last Name]", "Please enter your last name.");
    requireValue("contact[Company]", "Please enter your company name.");
    var email = field("contact[email]");
    var emailValue = selectedValue(form, "contact[email]");
    if (!emailValue || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue) || (email && email.validity && email.validity.valid === false)) {
      issues.push({ field: email, name: "contact[email]", message: "Please enter a valid email address." });
    }
    var country = field("contact[Country]");
    var countryValue = selectedValue(form, "contact[Country]");
    if (isPlaceholder(countryValue) || !resolveCountry(countryValue, countries)) {
      issues.push({ field: country, name: "contact[Country]", message: "Please select your country." });
    }
    requireValue("contact[Product]", "Please select a product.");
    if (context === "portable_power" || context === "consumer") requireValue("contact[Estimated Quantity]", "Please select an estimated quantity.");
    return issues;
  }

  function ensureCompanyRequiredLabel(label, documentLike) {
    var markers = label.querySelectorAll("sup");
    var marker = markers[0] || documentLike.createElement("sup");
    Array.prototype.slice.call(markers, 1).forEach(function (duplicate) { duplicate.remove(); });
    Array.prototype.slice.call(label.childNodes).forEach(function (node) {
      if (node !== marker) node.remove();
    });
    marker.textContent = "*";
    label.appendChild(documentLike.createTextNode("Company Name"));
    label.appendChild(marker);
  }

  function quotationLayout(form, documentLike, windowLike) {
    function field(name) { return form.querySelector('[name="' + name + '"]'); }
    function wrapper(name) {
      var control = field(name);
      return control && control.closest && control.closest('[data-pf-type="Form2.Field"]');
    }
    var first = wrapper("contact[First Name]");
    var last = wrapper("contact[Last Name]");
    var company = wrapper("contact[Company]");
    var email = wrapper("contact[email]");
    var phone = wrapper("contact[Phone]");
    var country = wrapper("contact[Country]");
    var product = wrapper("contact[Product]");
    var rooms = field("contact[Number of Rooms]");
    var companyControl = field("contact[Company]");
    var contactRowOne = first && first.parentElement;
    var contactRowTwo = company && company.parentElement;
    var contactRowThree = phone && phone.parentElement;
    var productRow = product && product.parentElement;
    var productSection = productRow && productRow.parentElement;
    var hotelSection = form.querySelector("#HotelDiv");
    var companyLabel = company && company.querySelector("label");
    var roomsWrapper = rooms && rooms.closest && rooms.closest('[data-pf-type="Form2.Field"]');
    var roomsLabel = roomsWrapper && roomsWrapper.querySelector("label");
    var desktop;

    if (!first || !last || !company || !email || !phone || !country ||
        !contactRowOne || contactRowOne !== last.parentElement ||
        !contactRowTwo || contactRowTwo !== email.parentElement ||
        !contactRowThree || contactRowThree !== country.parentElement ||
        !productSection || !hotelSection || productSection.parentElement !== hotelSection.parentElement ||
        !companyControl || !companyLabel || !rooms || !roomsLabel ||
        !windowLike || typeof windowLike.matchMedia !== "function") {
      throw new Error("Quotation field layout configuration is unavailable.");
    }

    function correctCompanyLabel() { ensureCompanyRequiredLabel(companyLabel, documentLike); }
    correctCompanyLabel();
    if (documentLike.readyState !== "complete" && typeof windowLike.addEventListener === "function") {
      windowLike.addEventListener("load", correctCompanyLabel, { once: true });
    }
    companyControl.required = true;
    companyControl.setAttribute("required", "");

    rooms.required = false;
    rooms.removeAttribute("required");
    Array.prototype.forEach.call(roomsLabel.querySelectorAll("sup"), function (marker) { marker.remove(); });

    contactRowThree.insertBefore(company, phone);
    desktop = windowLike.matchMedia(DESKTOP_LAYOUT_QUERY);
    function applyContactOrder() {
      if (desktop.matches) {
        contactRowTwo.appendChild(country);
        contactRowTwo.appendChild(email);
      } else {
        contactRowTwo.appendChild(email);
        contactRowTwo.appendChild(country);
      }
    }
    applyContactOrder();
    if (typeof desktop.addEventListener === "function") desktop.addEventListener("change", applyContactOrder);
    else if (typeof desktop.addListener === "function") desktop.addListener(applyContactOrder);

    hotelSection.parentElement.insertBefore(productSection, hotelSection);
    return { applyContactOrder: applyContactOrder };
  }

  function normaliseSelectPlaceholders(form) {
    Array.prototype.forEach.call(form.querySelectorAll("select"), function (select) {
      Array.prototype.forEach.call(select.options || [], function (option) {
        if (!isPlaceholder(option.value) && !isPlaceholder(option.textContent)) return;
        var selected = option.selected || isPlaceholder(select.value);
        option.value = "";
        option.disabled = true;
        if (selected) {
          option.selected = true;
          select.value = "";
        }
      });
    });
  }

  function scaleVisibility(form) {
    var rooms = form.querySelector('[name="contact[Number of Rooms]"]');
    var quantity = form.querySelector('[name="contact[Estimated Quantity]"]');
    var roomsWrapper = rooms && rooms.closest && rooms.closest('[data-pf-type="Form2.Field"]');
    var quantityWrapper = quantity && quantity.closest && quantity.closest('[data-pf-type="Form2.Field"]');
    var roomsLabel = roomsWrapper && roomsWrapper.querySelector && roomsWrapper.querySelector("label");
    if (!rooms || !quantity || !roomsWrapper || !quantityWrapper) {
      throw new Error("Quotation scale field configuration is unavailable.");
    }
    function keepRoomsOptional() {
      rooms.required = false;
      rooms.removeAttribute("required");
      if (roomsLabel) {
        Array.prototype.forEach.call(roomsLabel.querySelectorAll("sup"), function (marker) { marker.remove(); });
      }
    }
    function setApplicable(control, wrapper, applicable) {
      wrapper.hidden = !applicable;
      if (applicable) wrapper.removeAttribute("aria-hidden");
      else {
        wrapper.setAttribute("aria-hidden", "true");
        control.value = "";
      }
      control.disabled = !applicable;
    }
    function update() {
      var context = CONTEXTS[selectedValue(form, "project_type")];
      var hotel = context === "hotel";
      var quantityContext = context === "portable_power" || context === "consumer";
      setApplicable(rooms, roomsWrapper, hotel);
      keepRoomsOptional();
      setApplicable(quantity, quantityWrapper, quantityContext);
    }
    form.addEventListener("change", function (event) {
      if (event.target && event.target.name === "project_type") update();
    }, true);
    update();
    return { update: update, roomsWrapper: roomsWrapper, quantityWrapper: quantityWrapper };
  }

  function validationPresenter(form, countries, documentLike) {
    var shown = new Map();
    var sequence = 0;
    form.setAttribute("novalidate", "novalidate");
    if (!documentLike.getElementById(VALIDATION_STYLE_ID)) {
      var style = documentLike.createElement("style");
      style.id = VALIDATION_STYLE_ID;
      style.textContent = FORM_SELECTOR + " .ta-quotation-invalid{border-color:#a55b42;box-shadow:0 0 0 1px rgba(165,91,66,.18)}" + FORM_SELECTOR + " .ta-quotation-guidance{color:#8a4935;font-size:.875em;line-height:1.35;margin:.3rem 0 .55rem}";
      documentLike.head.appendChild(style);
    }
    function clear(control) {
      var guidance = shown.get(control);
      if (!guidance) return;
      control.classList.remove("ta-quotation-invalid");
      control.removeAttribute("aria-invalid");
      var described = String(control.getAttribute("aria-describedby") || "").split(/\s+/).filter(function (id) { return id && id !== guidance.id; });
      if (described.length) control.setAttribute("aria-describedby", described.join(" "));
      else control.removeAttribute("aria-describedby");
      guidance.remove();
      shown.delete(control);
    }
    function show(issue) {
      var control = issue.field;
      if (!control || shown.has(control)) return;
      var guidance = documentLike.createElement("p");
      guidance.id = "ta-quotation-guidance-" + (++sequence);
      guidance.className = "ta-quotation-guidance";
      guidance.textContent = issue.message;
      control.classList.add("ta-quotation-invalid");
      control.setAttribute("aria-invalid", "true");
      control.setAttribute("aria-describedby", [control.getAttribute("aria-describedby"), guidance.id].filter(Boolean).join(" "));
      control.insertAdjacentElement("afterend", guidance);
      shown.set(control, guidance);
    }
    function currentIssues() { return validationIssues(form, countries); }
    function refreshExisting() {
      var invalid = new Set(currentIssues().map(function (issue) { return issue.field; }));
      Array.from(shown.keys()).forEach(function (control) { if (!invalid.has(control)) clear(control); });
    }
    form.addEventListener("input", refreshExisting, true);
    form.addEventListener("change", refreshExisting, true);
    return {
      validate: function () {
        var issues = currentIssues();
        var invalid = new Set(issues.map(function (issue) { return issue.field; }));
        Array.from(shown.keys()).forEach(function (control) { if (!invalid.has(control)) clear(control); });
        issues.forEach(show);
        if (issues[0] && issues[0].field) {
          if (issues[0].field.scrollIntoView) issues[0].field.scrollIntoView({ behavior: "smooth", block: "center" });
          if (issues[0].field.focus) issues[0].field.focus({ preventScroll: true });
        }
        return { valid: issues.length === 0, issues: issues };
      }
    };
  }

  function productIdentityFromUrl(raw, locationLike) {
    var url;
    var parts;
    var productIndex;
    if (!raw) return null;
    try {
      url = new URL(raw, locationLike.origin);
    } catch (_error) {
      return null;
    }
    if (url.protocol !== "https:" || !["teleadapt.com", "www.teleadapt.com"].includes(url.hostname)) return null;
    parts = url.pathname.split("/").filter(Boolean);
    productIndex = parts.indexOf("products");
    if (productIndex < 0 || productIndex !== parts.length - 2 || !/^[a-z0-9][a-z0-9-]*$/.test(parts[productIndex + 1])) return null;
    return { handle: parts[productIndex + 1], url: "/products/" + parts[productIndex + 1] };
  }

  function productProvenance(locationLike) {
    var params = new URLSearchParams(locationLike.search || "");
    return productIdentityFromUrl(params.get("ref_url"), locationLike);
  }

  function normaliseProductTitle(value) {
    return String(value || "").trim().replace(/\s+/g, " ").toLocaleLowerCase();
  }

  function canonicalSearchProduct(product) {
    var handle = product && typeof product.handle === "string" ? product.handle.trim() : "";
    var title = product && typeof product.title === "string" ? product.title.trim() : "";
    if (!handle || !title || !/^[a-z0-9][a-z0-9-]*$/.test(handle)) return null;
    return { name: title, handle: handle, url: "/products/" + handle };
  }

  function productResolver(dependencies) {
    var cache = new Map();

    function runtimeLookup(selectedTitle) {
      var key = normaliseProductTitle(selectedTitle);
      var root = dependencies.routesRoot || "/";
      var url;
      if (cache.has(key)) return Promise.resolve(cache.get(key));
      url = root + "search/suggest.json?q=" + encodeURIComponent(selectedTitle)
        + "&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show&resources[options][fields]=title";
      return dependencies.fetch(url, { headers: { Accept: "application/json" } }).then(function (response) {
        if (!response.ok) throw new Error("product_lookup_failed");
        return response.json();
      }).then(function (body) {
        var products = body && body.resources && body.resources.results && body.resources.results.products;
        var exact = Array.isArray(products) ? products.map(canonicalSearchProduct).filter(function (product) {
          return product && normaliseProductTitle(product.name) === key;
        }) : [];
        if (exact.length !== 1) throw new Error(exact.length > 1 ? "product_lookup_ambiguous" : "product_lookup_unresolved");
        cache.set(key, exact[0]);
        return exact[0];
      });
    }

    return function resolve(selectedTitle, locationLike, referrer) {
      var explicit = productProvenance(locationLike);
      var referrerIdentity;
      if (explicit) return Promise.resolve({ name: selectedTitle, handle: explicit.handle, url: explicit.url, source: "ref_url" });
      referrerIdentity = productIdentityFromUrl(referrer, locationLike);
      return runtimeLookup(selectedTitle).then(function (runtimeIdentity) {
        if (referrerIdentity && referrerIdentity.handle === runtimeIdentity.handle) {
          return { name: runtimeIdentity.name, handle: runtimeIdentity.handle, url: runtimeIdentity.url, source: "document_referrer" };
        }
        return { name: runtimeIdentity.name, handle: runtimeIdentity.handle, url: runtimeIdentity.url, source: "shopify_runtime" };
      });
    };
  }

  function projectScale(value, context) {
    var scales = context === "hotel" ? PROJECT_SCALES.hotel : PROJECT_SCALES.quantity;
    value = String(value || "").trim();
    if (!value && context === "hotel") return null;
    if (!Object.prototype.hasOwnProperty.call(scales, value)) {
      throw new Error("Please select a valid project scale.");
    }
    return Object.assign({}, scales[value]);
  }

  function marketingAction(state, choice) {
    if (state === "offer") return choice === true ? "opt_in" : choice === false ? "decline" : "no_change";
    if (state === "re_offer") return choice === true ? "opt_in" : "no_change";
    return "no_change";
  }

  function marketingChoiceRequired(state, choice) {
    return (state === "offer" || state === "re_offer") && choice === null;
  }

  function buildPayload(form, locationLike, countries, resolvedIdentity, selectedMarketingAction) {
    var params = new URLSearchParams(locationLike.search || "");
    var contextLabel = selectedValue(form, "project_type");
    var context = CONTEXTS[contextLabel];
    var countryValue = selectedValue(form, "contact[Country]");
    var country = resolveCountry(countryValue, countries);
    var productName = selectedValue(form, "contact[Product]");
    var productNumber = selectedValue(form, "contact[Product Number (Optional)]") || String(params.get("pno") || "").trim();
    var provenance = resolvedIdentity || productProvenance(locationLike);
    var scale;
    var consent = form.querySelector('input[name="subscribe_newsletter"][value="1"]');

    if (!context) throw new Error("Please select a quotation type.");
    if (!country || isPlaceholder(countryValue)) throw new Error("Please select a valid country.");
    if (!productName || isPlaceholder(productName)) throw new Error("Please select a product.");
    if (!provenance) throw new Error(PRODUCT_RESOLUTION_ERROR);
    if (!consent) throw new Error("Marketing consent configuration is unavailable.");

    scale = projectScale(
      selectedValue(form, context === "hotel" ? "contact[Number of Rooms]" : "contact[Estimated Quantity]"),
      context
    );

    return {
      contract_version: "1.4",
      quotation_type: "product",
      products: [{
        name: provenance.name || productName,
        number: optional(productNumber),
        handle: provenance.handle,
        family: null,
        url: provenance.url
      }],
      context: {
        business_context: context,
        business_context_source: "product_single_context",
        product_contexts: [context]
      },
      project: {
        name: optional(selectedValue(form, "contact[Hotel/Property Name]")),
        scale: scale,
        timeframe: optional(selectedValue(form, "contact[Project Timeframe]")),
        narrative: optional(selectedValue(form, "contact[Additional Information]"))
      },
      contact: {
        first_name: selectedValue(form, "contact[First Name]"),
        last_name: selectedValue(form, "contact[Last Name]"),
        company: selectedValue(form, "contact[Company]"),
        email: selectedValue(form, "contact[email]"),
        phone: optional(selectedValue(form, "contact[Phone]")),
        country_code: country.code,
        country_name: country.name,
        client_assigned_sales_office: country.assigned_sales_office
      },
      consent: { marketing_action: selectedMarketingAction || "no_change" },
      attribution: {
        invocation_source: "quotation",
        selection_source: "product_search",
        referrer: productProvenance(locationLike) ? optional(params.get("ref_url")) : null,
        campaign: null
      }
    };
  }

  function normaliseEmail(value) {
    return String(value || "").trim().toLocaleLowerCase();
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normaliseEmail(value));
  }

  function subscriptionExperience(dependencies) {
    var form = dependencies.form;
    var email = form.querySelector('[name="contact[email]"]');
    var legacyConsent = form.querySelector('input[name="subscribe_newsletter"][value="1"]');
    var legacyLabel = legacyConsent && legacyConsent.closest("label");
    var root = legacyLabel && legacyLabel.parentElement ? legacyLabel.parentElement : legacyConsent && legacyConsent.parentElement;
    var disabledByCaller = new URLSearchParams(dependencies.location.search || "").get("subscribe") === "false";
    var state = "unresolved";
    var pendingEmail = "";
    var activeEmail = "";
    var resolvedEmail = "";
    var choice = null;
    var generation = 0;
    var debounceId = null;
    var watchdogId = null;
    var requestController = null;
    var widgetId = null;
    var choiceGroup = null;
    var choiceGuidance = null;
    var resolutionStartedAt = 0;
    var turnstileStartedAt = 0;
    var waiters = [];
    var lastSyncedEmail = null;

    if (!email || !legacyConsent || !root) throw new Error("Marketing consent configuration is unavailable.");
    legacyConsent.checked = false;
    legacyConsent.disabled = true;

    function diagnose(next, details) {
      state = next;
      form.dataset.taSubscriptionState = next;
      if (window.console && window.console.debug) window.console.debug("[TA subscription state]", next, details || {});
    }

    function settleWaiters() {
      var pending = waiters.splice(0);
      pending.forEach(function (resolve) { resolve(); });
    }

    function removeWidget() {
      if (widgetId !== null && window.turnstile && window.turnstile.remove) {
        try { window.turnstile.remove(widgetId); } catch (_error) { }
      }
      widgetId = null;
      dependencies.widgetContainer.replaceChildren();
    }

    function cancelCurrent() {
      generation += 1;
      if (debounceId !== null) window.clearTimeout(debounceId);
      if (watchdogId !== null) window.clearTimeout(watchdogId);
      debounceId = null;
      watchdogId = null;
      pendingEmail = "";
      activeEmail = "";
      if (requestController) requestController.abort();
      requestController = null;
      removeWidget();
      settleWaiters();
    }

    function suppress() {
      clearChoiceInvalid();
      root.hidden = true;
      root.setAttribute("aria-hidden", "true");
      root.replaceChildren(legacyLabel || legacyConsent);
      choiceGroup = null;
      choice = null;
    }

    function clearChoiceInvalid() {
      if (choiceGroup) {
        choiceGroup.removeAttribute("aria-invalid");
        choiceGroup.removeAttribute("aria-describedby");
        choiceGroup.style.borderLeft = "";
        choiceGroup.style.padding = "";
        choiceGroup.style.borderRadius = "";
      }
      if (choiceGuidance) choiceGuidance.remove();
      choiceGuidance = null;
    }

    function showChoiceInvalid() {
      if (!choiceGroup) return;
      choiceGroup.setAttribute("aria-invalid", "true");
      choiceGroup.style.borderLeft = "3px solid #a55b42";
      choiceGroup.style.padding = "8px 10px";
      choiceGroup.style.borderRadius = "4px";
      if (!choiceGuidance) {
        choiceGuidance = document.createElement("p");
        choiceGuidance.id = "ta-marketing-choice-guidance";
        choiceGuidance.textContent = "Please choose an option.";
        choiceGuidance.style.color = "#8a4935";
        choiceGuidance.style.fontSize = ".875em";
        choiceGuidance.style.fontWeight = "normal";
        choiceGuidance.style.lineHeight = "1.35";
        choiceGuidance.style.margin = ".3rem 0 0";
        choiceGroup.insertAdjacentElement("afterend", choiceGuidance);
      }
      choiceGroup.setAttribute("aria-describedby", choiceGuidance.id);
    }

    function renderChoice(next) {
      var reOffer = next === "re_offer";
      var heading = document.createElement("h3");
      var body = document.createElement("p");
      var group = document.createElement("div");
      var yesLabel = document.createElement("label");
      var noLabel = document.createElement("label");
      var yes = document.createElement("input");
      var no = document.createElement("input");
      heading.textContent = "Keep in touch?";
      body.textContent = reOffer
        ? "We’d like to be able to keep you updated with future product news, hospitality technology insights and new product announcements. If you’d like to hear from TeleAdapt again, please update your preference below. You can unsubscribe at any time."
        : "We’d like to keep you updated with product updates, offers, and occasional newsletters from TeleAdapt. Please choose your preference below. You can unsubscribe at any time.";
      group.setAttribute("role", "radiogroup");
      group.setAttribute("aria-label", "Keep in touch preference");
      yes.type = no.type = "radio";
      yes.name = no.name = "ta_marketing_choice";
      yes.value = "yes";
      no.value = "no";
      yesLabel.append(yes, document.createTextNode(reOffer ? " Yes, I’d like to hear from TeleAdapt again." : " Yes, I’d like to receive product updates, offers, and occasional newsletters from TeleAdapt."));
      noLabel.append(no, document.createTextNode(reOffer ? " No, leave my preference unchanged." : " No thanks, just send my quotation."));
      heading.style.margin = "0 0 8px";
      heading.style.fontFamily = "Roboto, sans-serif";
      heading.style.fontSize = "22px";
      heading.style.fontWeight = "700";
      heading.style.lineHeight = "1.3";
      body.style.margin = "0 0 12px";
      body.style.fontSize = "16px";
      body.style.fontWeight = "normal";
      body.style.lineHeight = "1.5";
      group.style.display = "flex";
      group.style.flexDirection = "column";
      group.style.gap = "8px";
      [yesLabel, noLabel].forEach(function (label) {
        label.style.display = "flex";
        label.style.alignItems = "flex-start";
        label.style.gap = "8px";
        label.style.fontSize = "16px";
        label.style.fontWeight = "normal";
        label.style.lineHeight = "1.5";
      });
      [yes, no].forEach(function (radio) {
        radio.style.margin = "0.2em 0 0";
        radio.style.flex = "0 0 auto";
      });
      group.append(yesLabel, noLabel);
      choiceGroup = group;
      choiceGuidance = null;
      if (legacyLabel) legacyLabel.hidden = true;
      root.replaceChildren(legacyLabel || legacyConsent, heading, body, group);
      root.style.marginBottom = "16px";
      root.hidden = false;
      root.removeAttribute("aria-hidden");
      group.addEventListener("change", function (event) {
        choice = event.target.value === "yes";
        clearChoiceInvalid();
        dependencies.onChoiceChanged();
      });
    }

    function finish(next, lookupGeneration, emailSnapshot, details) {
      if (lookupGeneration !== generation || normaliseEmail(email.value) !== emailSnapshot) return;
      if (watchdogId !== null) window.clearTimeout(watchdogId);
      watchdogId = null;
      requestController = null;
      activeEmail = "";
      removeWidget();
      resolvedEmail = emailSnapshot;
      choice = null;
      diagnose(next, details);
      if (next === "offer" || next === "re_offer") renderChoice(next);
      else suppress();
      settleWaiters();
    }

    function abandon(reason, lookupGeneration, emailSnapshot) {
      if (lookupGeneration !== generation || normaliseEmail(email.value) !== emailSnapshot) return;
      if (requestController) requestController.abort();
      finish("lookup_abandoned", lookupGeneration, emailSnapshot, {
        reason: reason,
        total_duration_ms: Date.now() - resolutionStartedAt
      });
    }

    function requestState(token, lookupGeneration, emailSnapshot) {
      var apiStartedAt = Date.now();
      if (lookupGeneration !== generation || normaliseEmail(email.value) !== emailSnapshot) return;
      requestController = new AbortController();
      dependencies.fetch(dependencies.stateEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: emailSnapshot, turnstile_token: token }),
        signal: requestController.signal
      }).then(function (response) {
        return response.json().then(function (body) { return { response: response, body: body }; });
      }).then(function (outcome) {
        var next = outcome.body && outcome.body.result && outcome.body.result.state;
        if (!outcome.response.ok || outcome.body.success !== true || SUBSCRIPTION_STATES.indexOf(next) === -1) throw new Error("state_lookup_failed");
        finish(next, lookupGeneration, emailSnapshot, {
          turnstile_duration_ms: apiStartedAt - turnstileStartedAt,
          api_duration_ms: Date.now() - apiStartedAt,
          total_duration_ms: Date.now() - resolutionStartedAt
        });
      }).catch(function (error) {
        if (error && error.name === "AbortError") return;
        finish("lookup_failed", lookupGeneration, emailSnapshot, { reason: "request_failed" });
      });
    }

    function beginLookup(emailSnapshot, lookupGeneration) {
      if (lookupGeneration !== generation || normaliseEmail(email.value) !== emailSnapshot) return;
      debounceId = null;
      pendingEmail = "";
      activeEmail = emailSnapshot;
      resolutionStartedAt = Date.now();
      turnstileStartedAt = Date.now();
      diagnose("resolving");
      watchdogId = window.setTimeout(function () { abandon("timeout", lookupGeneration, emailSnapshot); }, SUBSCRIPTION_BUDGET_MS);
      dependencies.loadTurnstile().then(function (turnstile) {
        if (lookupGeneration !== generation || normaliseEmail(email.value) !== emailSnapshot) return;
        widgetId = turnstile.render(dependencies.widgetContainer, {
          sitekey: TURNSTILE_SITE_KEY,
          execution: "execute",
          appearance: "interaction-only",
          action: "subscription_state",
          callback: function (token) { requestState(token, lookupGeneration, emailSnapshot); },
          "before-interactive-callback": function () { abandon("interaction_required", lookupGeneration, emailSnapshot); },
          "error-callback": function () { finish("lookup_failed", lookupGeneration, emailSnapshot, { reason: "turnstile_error" }); },
          "expired-callback": function () { finish("lookup_failed", lookupGeneration, emailSnapshot, { reason: "turnstile_expired" }); },
          "timeout-callback": function () { abandon("turnstile_timeout", lookupGeneration, emailSnapshot); }
        });
        turnstile.execute(widgetId);
      }).catch(function () { finish("lookup_failed", lookupGeneration, emailSnapshot, { reason: "turnstile_unavailable" }); });
    }

    function schedule(immediate) {
      var current = normaliseEmail(email.value);
      if (current === resolvedEmail && SUBSCRIPTION_STATES.indexOf(state) !== -1) return;
      if (state === "resolving" && current === activeEmail) return;
      if (debounceId !== null && current === pendingEmail) {
        if (immediate) {
          window.clearTimeout(debounceId);
          debounceId = window.setTimeout(function () { beginLookup(current, generation); }, 0);
        }
        return;
      }
      cancelCurrent();
      choice = null;
      resolvedEmail = "";
      suppress();
      diagnose(disabledByCaller ? "lookup_abandoned" : "unresolved", disabledByCaller ? { reason: "subscribe_false" } : null);
      if (disabledByCaller || !validEmail(current)) return;
      pendingEmail = current;
      debounceId = window.setTimeout(function () { beginLookup(current, generation); }, immediate ? 0 : SUBSCRIPTION_DEBOUNCE_MS);
    }

    email.addEventListener("input", function () { schedule(false); });
    email.addEventListener("blur", function () { if (validEmail(email.value)) schedule(true); });
    suppress();
    if (disabledByCaller) diagnose("lookup_abandoned", { reason: "subscribe_false" });
    else schedule(false);

    return {
      marketingAction: function () { return marketingAction(state, choice); },
      validateChoice: function () {
        if (marketingChoiceRequired(state, choice)) {
          showChoiceInvalid();
          var first = root.querySelector('input[type="radio"]');
          if (first) first.focus();
          return false;
        }
        return true;
      },
      waitForResolution: function () {
        if (state !== "resolving") return Promise.resolve();
        return new Promise(function (resolve) { waiters.push(resolve); });
      },
      syncFromCurrentDom: function () {
        var current = normaliseEmail(email.value);
        if (current === lastSyncedEmail) return;
        lastSyncedEmail = current;
        schedule(true);
      },
      state: function () { return state; }
    };
  }

  function validSuccess(response, body) {
    return Boolean(response && response.ok && body && body.success === true && body.result === "quotation_received" && body.contract_version === "1.4" && /^QTA-\d{8}-\d{6}$/.test(body.quotation_reference));
  }

  function buttonProgress(button, documentLike) {
    var originalContent = button.innerHTML;
    var active = false;

    if (!documentLike.getElementById(PROGRESS_STYLE_ID)) {
      var style = documentLike.createElement("style");
      style.id = PROGRESS_STYLE_ID;
      style.textContent = "@keyframes ta-quotation-spin{to{transform:rotate(360deg)}}.ta-quotation-spinner{display:inline-block;width:1em;height:1em;box-sizing:border-box;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:ta-quotation-spin .7s linear infinite;vertical-align:-.125em;margin-right:.5em;flex:0 0 auto}";
      documentLike.head.appendChild(style);
    }

    function showActive() {
      if (active) return;
      var spinner = documentLike.createElement("span");
      spinner.className = "ta-quotation-spinner";
      spinner.setAttribute("aria-hidden", "true");
      button.replaceChildren(spinner, documentLike.createTextNode("Submitting…"));
      button.setAttribute("aria-busy", "true");
      active = true;
    }

    function showInactive() {
      if (active) button.innerHTML = originalContent;
      button.removeAttribute("aria-busy");
      active = false;
    }

    return {
      update: function (state) {
        if (["resolving_product", "awaiting_turnstile", "submitting", "success"].includes(state)) showActive();
        else showInactive();
      },
      isActive: function () { return active; }
    };
  }

  function controller(dependencies) {
    var state = "idle";
    var requestStarted = false;
    var widgetId = null;
    var pendingPayload = null;
    var form = dependencies.form;
    var button = dependencies.button;
    var progress = dependencies.progress;

    function setState(next, message, disabled) {
      state = next;
      button.disabled = disabled;
      progress.update(next);
      if (["resolving_product", "awaiting_turnstile", "submitting", "success"].includes(next)) form.setAttribute("aria-busy", "true");
      else form.removeAttribute("aria-busy");
      dependencies.setStatus(message);
    }

    function recover(message) {
      requestStarted = false;
      pendingPayload = null;
      setState("recoverable_error", message, false);
      if (widgetId !== null && dependencies.turnstile && dependencies.turnstile.reset) dependencies.turnstile.reset(widgetId);
    }

    function submitToken(token) {
      var envelope;
      if (requestStarted || state !== "awaiting_turnstile") return Promise.resolve();
      requestStarted = true;
      setState("submitting", "Please wait while we submit your quotation.", true);
      envelope = { payload: pendingPayload, turnstile_token: token };
      return dependencies.fetch(dependencies.endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(envelope)
      }).then(function (response) {
        return response.json().then(function (body) { return { response: response, body: body }; });
      }).then(function (outcome) {
        if (!validSuccess(outcome.response, outcome.body)) {
          recover(outcome.body && outcome.body.result === "turnstile_failed" ? "Verification failed. Please try again." : "We could not submit your request. Please review the form and try again.");
          return;
        }
        setState("success", "Please wait while we submit your quotation.", true);
        dependencies.storeReference(outcome.body.quotation_reference);
        dependencies.navigate(THANK_YOU_PATH);
      }).catch(function () {
        requestStarted = true;
        setState("recoverable_error", "We could not confirm whether your request was received. Please do not submit repeatedly; contact TeleAdapt if you need assistance.", true);
      });
    }

    function begin() {
      var productName;
      if (["validating", "resolving_product", "awaiting_turnstile", "submitting", "success"].includes(state) || requestStarted) return;
      setState("validating", "Checking your request…", false);
      var validation = dependencies.validateForm ? dependencies.validateForm() : { valid: form.checkValidity ? form.checkValidity() : true };
      if (!validation.valid) {
        setState("recoverable_error", "Please complete the highlighted fields.", false);
        return;
      }
      if (dependencies.subscriptionExperience && dependencies.subscriptionExperience.state() === "resolving") {
        setState("validating", "Checking your request…", true);
        dependencies.subscriptionExperience.waitForResolution().then(function () {
          setState("idle", "", false);
          begin();
        });
        return;
      }
      if (dependencies.subscriptionExperience && !dependencies.subscriptionExperience.validateChoice()) {
        setState("recoverable_error", "Please choose your Keep in touch preference.", false);
        return;
      }
      if (selectedValue(form, "middleName")) {
        setState("recoverable_error", "We could not submit your request.", true);
        return;
      }
      productName = dependencies.selectedProductName ? dependencies.selectedProductName() : "";

      function continueSubmission(identity) {
        var currentValidation = dependencies.validateForm ? dependencies.validateForm() : { valid: true };
        if (!currentValidation.valid) {
          setState("recoverable_error", "Please complete the highlighted fields.", false);
          return;
        }
        if (normaliseProductTitle(productName) !== normaliseProductTitle(dependencies.selectedProductName ? dependencies.selectedProductName() : productName)) {
          recover(PRODUCT_RESOLUTION_ERROR);
          return;
        }
        try {
          pendingPayload = dependencies.buildPayload(identity);
        } catch (error) {
          setState("recoverable_error", error.message, false);
          return;
        }
        setState("awaiting_turnstile", "Please wait while we submit your quotation.", true);
        dependencies.loadTurnstile().then(function (turnstile) {
          dependencies.turnstile = turnstile;
          widgetId = turnstile.render(dependencies.turnstileContainer, {
            sitekey: TURNSTILE_SITE_KEY,
            action: "quotation_submit",
            theme: "auto",
            callback: submitToken,
            "error-callback": function () { recover("Verification failed. Please try again."); },
            "expired-callback": function () { recover("Verification expired. Please try again."); },
            "timeout-callback": function () { recover("Verification timed out. Please try again."); }
          });
        }).catch(function () { recover("Verification is temporarily unavailable. Please try again."); });
      }

      if (!dependencies.resolveProductIdentity) {
        continueSubmission(null);
        return;
      }
      setState("resolving_product", "Please wait while we submit your quotation.", true);
      dependencies.resolveProductIdentity(productName).then(continueSubmission).catch(function () {
        recover(PRODUCT_RESOLUTION_ERROR);
      });
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      begin();
    }, true);
    form.submit = function () {
      begin();
    };
    button.addEventListener("click", function (event) {
      event.preventDefault();
      begin();
    });
    return { begin: begin, submitToken: submitToken, state: function () { return state; } };
  }

  function loadTurnstile() {
    var script;
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (turnstileLoadPromise) return turnstileLoadPromise;
    turnstileLoadPromise = new Promise(function (resolve, reject) {
      function loaded() { window.turnstile ? resolve(window.turnstile) : reject(new Error("Turnstile unavailable")); }
      script = document.querySelector('script[src="' + TURNSTILE_SCRIPT_URL + '"]');
      if (!script) {
        script = document.createElement("script");
        script.src = TURNSTILE_SCRIPT_URL;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
      script.addEventListener("load", loaded, { once: true });
      script.addEventListener("error", reject, { once: true });
    });
    return turnstileLoadPromise;
  }

  function initialise() {
    var script = document.currentScript || document.querySelector('script[src*="ta-quotation-form.js"]');
    var form = document.querySelector(FORM_SELECTOR);
    var button = document.querySelector(SUBMIT_SELECTOR);
    var status = document.getElementById(STATUS_ID);
    var turnstileContainer = document.getElementById(TURNSTILE_ID);
    var endpoint;
    var countries;
    var resolveProductIdentity;
    var subscriptionWidgetContainer;
    var subscription;
    var scaleController;
    if (!form || !button || !status || !turnstileContainer || !script) return;
    try {
      endpoint = endpointFor(script.dataset.apiBase);
      countries = countryIndex();
    } catch (error) {
      status.textContent = error.message;
      button.disabled = true;
      return;
    }
    if (form.dataset.taQuotationInitialised === "true") return;
    form.dataset.taQuotationInitialised = "true";
    try {
      quotationLayout(form, document, window);
      normaliseSelectPlaceholders(form);
      scaleController = scaleVisibility(form);
    } catch (error) {
      status.textContent = error.message;
      button.disabled = true;
      return;
    }
    var validator = validationPresenter(form, countries, document);
    subscriptionWidgetContainer = document.createElement("div");
    subscriptionWidgetContainer.setAttribute("data-ta-subscription-state-turnstile", "");
    form.appendChild(subscriptionWidgetContainer);
    subscription = subscriptionExperience({
      form: form,
      location: window.location,
      widgetContainer: subscriptionWidgetContainer,
      stateEndpoint: endpoint.replace(/\/quotations$/, "/subscribers/state"),
      loadTurnstile: loadTurnstile,
      fetch: window.fetch.bind(window),
      onChoiceChanged: function () {
        if (status.textContent === "Please choose your Keep in touch preference.") status.textContent = "";
      }
    });
    function syncAfterPageFlyPrefill() {
      scaleController.update();
      subscription.syncFromCurrentDom();
    }
    if (document.readyState === "complete") syncAfterPageFlyPrefill();
    else window.addEventListener("load", syncAfterPageFlyPrefill, { once: true });
    resolveProductIdentity = productResolver({
      fetch: window.fetch.bind(window),
      routesRoot: window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/"
    });
    controller({
      form: form,
      button: button,
      progress: buttonProgress(button, document),
      endpoint: endpoint,
      turnstileContainer: turnstileContainer,
      loadTurnstile: loadTurnstile,
      fetch: window.fetch.bind(window),
      selectedProductName: function () {
        return selectedValue(form, "contact[Product]");
      },
      validateForm: validator.validate,
      resolveProductIdentity: function (title) { return resolveProductIdentity(title, window.location, document.referrer); },
      subscriptionExperience: subscription,
      buildPayload: function (identity) { return buildPayload(form, window.location, countries, identity, subscription.marketingAction()); },
      setStatus: function (message) { status.textContent = message; },
      storeReference: function (reference) { window.sessionStorage.setItem(REFERENCE_STORAGE_KEY, reference); },
      navigate: function (path) { window.location.assign(path); }
    });
    status.textContent = "";
  }

  return {
    COUNTRY_CODES: COUNTRY_CODES,
    US_OFFICE_CODES: US_OFFICE_CODES,
    neutraliseLegacyShopifyContact: neutraliseLegacyShopifyContact,
    normaliseCountry: normaliseCountry,
    countryIndex: countryIndex,
    resolveCountry: resolveCountry,
    isPlaceholder: isPlaceholder,
    validationIssues: validationIssues,
    quotationLayout: quotationLayout,
    normaliseSelectPlaceholders: normaliseSelectPlaceholders,
    scaleVisibility: scaleVisibility,
    validationPresenter: validationPresenter,
    endpointFor: endpointFor,
    normaliseProductTitle: normaliseProductTitle,
    productIdentityFromUrl: productIdentityFromUrl,
    productProvenance: productProvenance,
    productResolver: productResolver,
    projectScale: projectScale,
    marketingAction: marketingAction,
    marketingChoiceRequired: marketingChoiceRequired,
    buildPayload: buildPayload,
    validSuccess: validSuccess,
    buttonProgress: buttonProgress,
    controller: controller,
    normaliseEmail: normaliseEmail,
    validEmail: validEmail,
    subscriptionExperience: subscriptionExperience,
    initialise: initialise
  };
});
